import UAParser from 'ua-parser-js';

const parser = new UAParser();
const { browser, device, os } = parser.getResult();

/**
 * @see https://github.com/modusign/modusign-client/blob/main/app/.browserslistrc
 */
const VERSIONS = {
  CHROME: 61,
  EDGE: 16,
  SAFARI: 11,
  FIREFOX: 60,
  OPERA: 48,
  // FIXME(@taehwanno): android browser version history가 찾기 힘듬. 기존 코드 구현 그대로 유지
  ANDROID_BROWSER: 5,
  // FIXME(@taehwanno): engine version이 기존에 왜 browser version으로 비교했었는지 맥락을 모르겠음
  WEBKIT: 602,
};

function browserCheck() {
  const major = parseInt(browser.major, 10);

  switch (browser.name) {
    case 'Chrome':
      return major >= VERSIONS.CHROME;
    case 'Firefox':
      return major >= VERSIONS.FIREFOX;
    case 'Safari':
      return major >= VERSIONS.SAFARI;
    case 'Opera':
      return major >= VERSIONS.OPERA;
    case 'Edge':
      return major >= VERSIONS.EDGE;
    default:
      return true;
  }
}

function mobileBrowserCheck() {
  const major = parseInt(browser.major, 10);

  if (os.name === 'iOS') {
    switch (browser.name) {
      case 'Chrome':
        return major >= VERSIONS.CHROME;
      case 'Chrome WebView':
        return major >= VERSIONS.CHROME;
      case 'Mobile Safari':
        return major >= VERSIONS.SAFARI;
      case 'WebKit':
        return major >= VERSIONS.WEBKIT;
      default:
        return false;
    }
  } else if (os.name === 'Android') {
    switch (browser.name) {
      case 'Chrome':
        return major >= VERSIONS.CHROME;
      case 'Chrome WebView':
        return major >= VERSIONS.CHROME;
      case 'Android Browser':
        return major >= 5;
      default:
        return false;
    }
  }

  return false;
}

if (process.env.REACT_APP_MODUSIGN_ENV === 'production') {
  switch (device.type) {
    case 'mobile':
    case 'tablet':
      if (!mobileBrowserCheck()) {
        window.location.replace('https://modusign.co.kr/mobile-browser-support');
      }
      break;
    default:
      // desktop일 때 ua-parser-js에서 device type이 undefined
      if (!device.type && !browserCheck()) {
        window.location.replace('https://modusign.co.kr/browser-support');
      }
      break;
  }
}
